import { render, staticRenderFns } from "./PhoneCard.vue?vue&type=template&id=73852311"
import script from "./PhoneCard.vue?vue&type=script&lang=js"
export * from "./PhoneCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports